module.exports = __webpack_public_path__ + "img/portugal.72dc7b50.svg";